import { useStore } from '@nanostores/react';
import { useCallback } from 'react';
import { MenuDropdownItem } from './BaseMenuDropdown';
import { menuStore, SettingsPage } from '~/lib/stores/menu';
import { projectStore } from '~/lib/stores/project';

export interface SubscriptionDropdownItemProps {
  isLoading: boolean;
}

export function SubscriptionMenuItem({ isLoading }: SubscriptionDropdownItemProps) {
  const permissions = useStore(projectStore.permissions);

  const handleSubscriptionsClick = useCallback(() => {
    menuStore.openDialog({ type: 'settings', initialPage: SettingsPage.SubscriptionAndTokens });
  }, []);

  if (!permissions.canOpenProjectSettings) {
    return null;
  }

  return (
    <MenuDropdownItem disabled={isLoading} onClick={handleSubscriptionsClick}>
      <span className="i-lucide:credit-card size-4 group-hover:text-bolt-elements-textPrimary" />
      Subscription
    </MenuDropdownItem>
  );
}
